import { TextCell } from '@common/components/TextCell';

interface FulfillmentTypeCellProps {
	fulfillmentType?: string;
}

export const FulfillmentTypeCell = ({ fulfillmentType }: FulfillmentTypeCellProps) => {
	return <TextCell value={fulfillmentType} />;
};
